/* Auto Generated */

export enum Size {
	small,
	large,
}
